import { lazyLoad } from 'utils/loadable';

export const CatalogCreate = lazyLoad(
  () => import('./catalogCreate.page'),
  (module) => module.CatalogCreate
);
